import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import {
  Wrapper,
  StyledContent,
  StyledIllustration,
  StyledTitle,
} from './styles';

const OfferListEmptyMessage = () => {
  const { market, t } = useAppContext();
  const {
    isAnyFilterToggledOnByUser,
    resetFilters,
  } = useOfferListFilterContext();

  if (!isAnyFilterToggledOnByUser()) {
    return null;
  }

  const handleButtonClick = () => {
    resetFilters();
  };

  return (
    <Wrapper>
      <StyledIllustration
        alt=""
        src={`${market.cdn}/g/rfe/illustrations/no-offers-illustration.png`}
        width={200}
        height={240}
      />
      <StyledContent>
        <StyledTitle>
          {t('product', 'price-list.no-matching-offers-in-filter')}
        </StyledTitle>
        <PrimaryButton onClick={handleButtonClick}>
          {t('filter', 'button.clear-filters')}
        </PrimaryButton>
      </StyledContent>
    </Wrapper>
  );
};

export default OfferListEmptyMessage;
